import React from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import styles from "./Layout.module.css";
import { Outlet } from "react-router-dom";

export const Layout: React.FC = () => {
    return (
        <div className={styles.layout}>
            <Sidebar />
            <main className={styles.content}>
                <Outlet />
            </main>
        </div>
    );
};
